<template>
  <FooterMobile v-if="isMobile" />
  <FooterPc v-else />
</template>

<script>
import { mapState } from 'vuex'
import FooterPc from './FooterPc.vue'
import FooterMobile from './FooterMobile.vue'

export default {
  components: {
    FooterPc,
    FooterMobile
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ])
  }
}
</script>
